module.exports = __webpack_public_path__ + "img/logo_vertical_fullName_white.7b38ea89.svg";